import React, { FC, useState } from 'react';
import classnames from 'classnames';

import { emailValidator } from 'utils/validators';

type Props = {
  onCancel: () => void;
  onSubmit: (recipientEmail: string, message: string) => void;
};

export const GiftWidget: FC<Props> = ({ onSubmit, onCancel }) => {
  const [recipientEmail, setRecipientEmail] = useState<string>('');
  const [message, setMessage] = useState('');
  const [showValidationError, setShowValidationError] = useState(false);
  const [showPersonalMessage, setShowPersonalMessage] = useState(false);
  const [processing, setProcessing] = useState(false);

  const handleFormSubmit: React.FormEventHandler = (event) => {
    event.preventDefault();
    setProcessing(true)

    const isEmailValid = emailValidator(recipientEmail);
    if (isEmailValid) {
      setShowValidationError(false);
      onSubmit(recipientEmail, message);
    } else {
      setProcessing(false)
      setShowValidationError(true);
    }
  };

  return (
    <form className='component-gift-widget mb-0' onSubmit={handleFormSubmit}>
      <h1 className='headline headline--sm mb-mini'>
        <span className='icon-gift mr-mini' />
        Gift For:
      </h1>
      <input
        onChange={(event) => {
          setShowValidationError(false);
          setRecipientEmail(event.target.value);
        }}
        type='text'
        className={classnames('w-100', { 'state-not-valid': showValidationError })}
        autoComplete='off'
        placeholder='Email'
      />
      <small className='muted mb-1 d-block'>Send gift to any email address.</small>
      <div className='mb-1'>
        <h2 className='headline headline--readable headline--sm fw-500 mb-mini'>You can also:</h2>
        <div>
          {showPersonalMessage ? (
            <textarea
              className='w-100'
              placeholder='Enter personal message'
              style={{ minHeight: 100 }}
              onChange={(event) => setMessage(event.target.value)}
            />
          ) : (
            <div>
              <span className='icon-mail mr-mini fs-16' />
              <button
                onClick={() => setShowPersonalMessage(true)}
                className='btn--anchor link-border'
              >
                Add a message
              </button>
            </div>
          )}
        </div>
      </div>
      <div className='d-flex'>
        <button
          role='button'
          type='button'
          onClick={onCancel}
          className='btn btn--border-dark w-100'
        >
          Cancel
        </button>
        <button role='button' className='btn btn--border-cta w-100' disabled={processing}>
          Gift
        </button>
      </div>
    </form>
  );
};
